import "./Login.scss";

import {
  Container,
  Grid,
  isWidthDown,
  Typography,
  withWidth,
} from "@material-ui/core";
import { ApiErrors } from "common/backend/api-errors/errors";
import { CommonErrorDialog } from "common/components/CommonErrorDialog";
import { SubmitButton } from "common/components/input/elements";
import { UserField, UserInputTypeKey } from "common/components/input/fields";
import { GetCurrentUserLazy, LoginUser } from "common/graphql/queryDescriptors";
import { useCustomQuery } from "common/store/hooks/useCustomQuery";
import { LoginUserManageable } from "common/store/user/types";
import { errorMessages } from "common/utils/validation";
import { ContentWrapper } from "components/ContentWrapper";
import { LanguageSwitch } from "components/LanguageSwitch";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

function Login({ width }: any) {
  // State
  const [error, setError] = useState("");

  // Hooks
  const history = useHistory();
  const { t } = useTranslation();

  const { execute: executeGetCurrentUser } = useCustomQuery(GetCurrentUserLazy({}));

  const { execute: login } = useCustomQuery(LoginUser({
    onSuccess: () => {
      executeGetCurrentUser();
    },
    onError: (error: ApiErrors) => {
      if (error === ApiErrors.USER_INVALID_CREDENTIALS) {
        setError(t("Wrong email or password"));
      }
    },
  }));

  // Options
  const initialValues = new LoginUserManageable();

  // Validation
  const onValidate = (values: LoginUserManageable) => {
    return new LoginUserManageable(values).validate(
      Object.keys(values),
      errorMessages
    );
  };

  const onSubmit = async (values: LoginUserManageable) => {
    await login({ variables: { input: new LoginUserManageable(values).serialize() } });
  };

  return (
    <ContentWrapper paddingTop="0px">
      <Formik
        initialValues={initialValues}
        validate={onValidate}
        onSubmit={onSubmit}
      >
        {(props) =>
          <Form className="login">
            <Container
              className={
                isWidthDown(
                  "xs",
                  width
                ) ? "container--mobile" : "container"
              }
            >
              <Grid container spacing={6}>
                <LanguageSwitch />

                <Grid item xs={12}>
                  <Typography className="title" color="primary">
                    {t("Log in")}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <UserField id={"email" as UserInputTypeKey} {...props} />
                </Grid>

                <Grid item xs={12}>
                  <UserField id={"password" as UserInputTypeKey} {...props} />
                </Grid>

                <Grid item xs={12}>
                  <SubmitButton
                    value={t("Log in")}
                    {...props}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography className="text--big">
                    {t("New to FinPro?")}{" "}
                    <span
                      className="text--link text--big"
                      onClick={() => history.push("/authentication/register")}
                    >
                      {t("Register now")}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Container>
          </Form>
        }
      </Formik>

      <CommonErrorDialog error={error} setError={setError} />
    </ContentWrapper>
  );
}

export default withWidth()(Login);
